import type { MarketVariants } from '@/lib/i18n'

export type RecoveryScamItem = { title: string; description: string }

export type Slide9RecoveryScamCopy = {
  title: string
  body: string
  listHeading: string
  items: RecoveryScamItem[]
}

export const copy: MarketVariants<Slide9RecoveryScamCopy> = {
  US: {
    title: 'Watch for the second wave.',
    body: 'Once someone is scammed, their details get shared and sold between criminals. A new scam often follows, wearing a different face. Remember, real help never asks you to pay upfront.',
    listHeading: 'Common recovery scams',
    items: [
      {
        title: 'Fake recovery agents',
        description: 'Promise to get your money back for a fee.',
      },
      {
        title: 'Fake police or investigators',
        description: 'Ask for account details to “track” the scammer.',
      },
      {
        title: 'A new “friend” online',
        description: 'Understands exactly what you just went through.',
      },
    ],
  },
  ar: {
    title: 'انتبه للموجة الثانية.',
    body: 'بعد تعرّض شخص للاحتيال، تُتداول بياناته وتُباع بين المجرمين. وكثيراً ما يتبع ذلك احتيال جديد بوجه مختلف. تذكّر: المساعدة الحقيقية لا تطلب منك الدفع مقدّماً أبداً.',
    listHeading: 'أشهر عمليات احتيال استرداد الأموال',
    items: [
      {
        title: 'وكلاء استرداد وهميون',
        description: 'يعدونك باستعادة أموالك مقابل رسوم.',
      },
      {
        title: 'شرطة أو محققون مزيّفون',
        description: 'يطلبون بيانات حسابك "لتعقّب" المحتال.',
      },
      {
        title: '"صديق" جديد على الإنترنت',
        description: 'يفهم تماماً ما مررت به للتو.',
      },
    ],
  },
}
